import React from 'react';
import { X, Building2 } from 'lucide-react';

export function BizDetailModal({ isOpen, onClose, detailData }) {
  if (!isOpen || !detailData) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200 p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white shadow-2xl animate-in zoom-in-95 duration-200 max-h-full flex flex-col">
        
        <div className="flex flex-shrink-0 items-center justify-between border-b border-slate-100 px-6 py-4">
          <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
            <Building2 className="h-5 w-5 text-blue-600" />
            사업장 상세 정보
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 border-none outline-none">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 space-y-6 overflow-y-auto custom-scrollbar flex-1">
          
          <div className="grid grid-cols-2 gap-y-4 gap-x-8">
            <div className="border-b pb-2 col-span-2">
              <h4 className="text-sm font-bold text-slate-800">1. 기본 정보</h4>
            </div>

            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">사업자등록번호</p>
              <p className="text-sm text-slate-900 font-medium">{detailData.bizRegNo || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">사업장관리번호</p>
              <p className="text-sm text-slate-900 font-medium">{detailData.bizMgtNo || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">사업장명</p>
              <p className="text-sm text-slate-900 font-bold">{detailData.bizName || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">대표자명</p>
              <p className="text-sm text-slate-900">{detailData.ceoName || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">상시근로자수</p>
              <p className="text-sm text-slate-900">{detailData.employeeCount ? `${Number(detailData.employeeCount).toLocaleString()}명` : '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">업종 / 종목</p>
              <p className="text-sm text-slate-900">{detailData.businessType || '-'} / {detailData.businessItem || '-'}</p>
            </div>
            <div className="col-span-2 pt-2 border-t border-slate-100 mt-2">
              <p className="block text-xs font-semibold text-slate-500 mb-3">주소 정보</p>
              <div className="space-y-4">
                <div>
                  <p className="text-xs font-semibold text-slate-400 mb-1">우편번호</p>
                  <p className="text-sm text-slate-900">{detailData.zipcode || '-'}</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-slate-400 mb-1">소재지 (기본 및 상세 주소)</p>
                  <p className="text-sm text-slate-900">{detailData.address1 || '-'} {detailData.address2 || ''}</p>
                </div>
              </div>
            </div>

            <div className="border-b pb-2 col-span-2 mt-2">
              <h4 className="text-sm font-bold text-slate-800">2. 담당자 및 연락처 정보</h4>
            </div>

            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">현장 연락처</p>
              <p className="text-sm text-slate-900">{detailData.bizPhone || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">팩스번호</p>
              <p className="text-sm text-slate-900">{detailData.faxPhone || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">담당자명</p>
              <p className="text-sm text-slate-900">{detailData.managerName || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">담당자 연락처</p>
              <p className="text-sm text-slate-900">{detailData.managerPhone || '-'}</p>
            </div>
            <div className="col-span-2">
              <p className="text-xs font-semibold text-slate-500 mb-1">담당자 이메일</p>
              <p className="text-sm text-slate-900">{detailData.managerEmail || '-'}</p>
            </div>

            <div className="border-b pb-2 col-span-2 mt-2">
              <h4 className="text-sm font-bold text-slate-800">3. 관리 정보</h4>
            </div>

            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">등록지사</p>
              <p className="text-sm text-slate-900"><span className="inline-flex rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">{detailData.regBranch || '-'}</span></p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">상태 (폐업여부)</p>
              <p className="text-sm text-slate-900">{detailData.closeYn === 'Y' ? '폐업/소멸' : '정상'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">성립일</p>
              <p className="text-sm text-slate-900">{detailData.estabDate || '-'}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 mb-1">소멸일</p>
              <p className="text-sm text-slate-900">{detailData.closeDate || '-'}</p>
            </div>

          </div>
        </div>

        <div className="flex flex-shrink-0 items-center justify-end rounded-b-2xl bg-slate-50 px-6 py-4 border-t border-slate-100">
          <button type="button" onClick={onClose} className="rounded-lg bg-white border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 shadow-sm transition-colors">
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
